// extracted by mini-css-extract-plugin
export default {"wrapper":"AlarmWrapper_wrapper__7-tmZ","title":"AlarmWrapper_title__MfZUM","item":"AlarmWrapper_item__YBxqA"};